module.exports = __webpack_public_path__ + "static/media/buildingConstruction8.c5b8ae4a.jpg";